import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as apiUtility from '../../config/APIUtils';
import React from "react";
import { useState, useEffect } from "react";

const BASE_URL_EMAIL_TO_EMPLOYER = "user/sendEmailEmp";
const BASE_URL_GET_ALLCOURSE_VERSIONS_USER_BASED = "course/getAllCourseVersion_forUser";

/***
 * 
 * @param {{}} [userData={}] 
 * @param {{}} [courseDataHistory={}] 
 * @param {[]} [courseHistory=[]] 
 * @param {{}} [trainingProviders={}] 
 * @param {string} [reportName=''] 
 * @param {string} [fileName=''] 
 * @param {boolean} [isEmail=false] 
 * @param {string} [reportType=1] 
 * 
 */
export async function coursePdfReport(userData = {}, history = {}, courseHistory = [], trainingProviders = {}, reportName = '', fileName = '', isEmail = false, reportType = 1) {
    let responseBody = {};
      var training_Providers=[];
        
        var userDetails = {};

    try {
         function formatDateOnly(dateString) {
            console.log(dateString)
        // Clean the AM/PM part
        const cleaned = dateString.replace(/\./g, '').toUpperCase();

        const date = new Date(cleaned);

        if (isNaN(date)) return "Invalid date";

        // Return only dd/mm/yyyy
        return date.toLocaleDateString('en-GB'); 
        }
        console.log(trainingProviders)

        const unit = "pt";
        const size = "A4";
        const orientation = "portrait";
        const compress = true;
        const fontSize = 8;
        const lineHeight = 1;
        const autoSize = false;
        const printHeaders = true;
        const doc = new jsPDF(orientation, unit, size, compress, fontSize, lineHeight, autoSize, printHeaders);
        var rowsCount = 6;
        doc.setFontSize(15);
        const title = "Care Passport\n" + reportName;

        var userBody = [{}];
        var userHeader = [{}];
        userHeader = [{ 'first': 'Name : ' + userData.firstName + " " + userData.lastName, 'sec': ' ' }];
        userBody = [{ 'first': 'UserId : ' + userData.user_id, 'sec': 'Home : ' + userData.homeName },
        { 'first': 'Date Of Birth : ' + userData.dob, 'sec': 'Role : ' + userData.roleName },
        { 'first': 'Date : ' + new Date().toLocaleString(), 'sec': ' ' }]

        const lineColor = '#cccccc';
        doc.setDrawColor(lineColor);
        const titleHeight = 55;
        const infoHeaderHeight = 150;

        const pageWidth = doc.internal.pageSize.getWidth() - 20;
        doc.rect(40, 20, pageWidth - 60, titleHeight);
        doc.rect(40, 20, pageWidth - 60, infoHeaderHeight);
        autoTable(doc, {
            head: userHeader,
            body: userBody,
            styles: { font: 'helvetica', cellWidth: 'wrap' },
            startY: 80,
            theme: 'plain'
        });
        const totalHeight = titleHeight + infoHeaderHeight + 15;


        let headers = [['Course Code', 'Title', 'Version','Training Provider', 'Date', 'Expiry Date', 'Status']];
        let tableData = [];
        console.log(userData,history)
        

        for (let item of history) {
            rowsCount += 1;
            let courseRecords = [
                item.course_id,
                item.courseVersion.title,
                item.course_version_id,
                // item.tp_course_code,
                (trainingProviders.find(item=>item.tp_id==parseInt(item.tp_id)).provider_name),
                (item.completion_date !== "") ? formatDateOnly(item.completion_date) : "N/A",
                (item.expiry_date !== "") ? new Date(item.expiry_date).toLocaleDateString() : "",
                 item.verification ,
            ];
            tableData.push(courseRecords);
        }

        let content = {
            startY: doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 15 : totalHeight,
            styles: { font: 'helvetica', cellWidth: 'auto', minCellWidth: 2 },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },//, fillColor: [0, 255, 0]}}, // Cells in first column centered and green
            headStyles: {
                fillColor: [0, 102, 153], halign: 'center'
            },
            margin: { top: 30 },
            head: headers,
            body: tableData,
            theme: 'grid'
        };
        autoTable(doc, content);


        doc.setProperties({
            title: title,
            subject: 'Carepasport auto generated reports',
            author: 'Carepassport',
            keywords: 'generated, javascript, web 2.0, ajax',
            creator: 'Carepassport',
            bodyStyles: {
                color: '#cccccc'
            }
        });
        doc.setFontSize(15);
        doc.text(title, 300, 40, {
            align: 'center'
        });


        doc.save(fileName != '' ? fileName + ".pdf" : "Carepassport_" + userData.user_id + ".pdf");
        return responseBody = { code: 200, message: 'File downloaded successfully' };
    } catch (error) {
        console.log("error : ", error);
        return responseBody = { code: 200, message: error };
    }
}